const MILLION = 1_000_000;

const formatMillionValue = (value: number) => {
  const millionValue = Number(value || 0) / MILLION;
  const rounded = Math.round(millionValue * 10) / 10;

  return Number.isInteger(rounded)
    ? String(rounded)
    : String(rounded).replace('.', ',');
};

export const formatSalaryRange = (min: number, max: number) => {
  const minLabel = formatMillionValue(min);
  const maxLabel = formatMillionValue(max);

  if (Number(min) === Number(max)) {
    return `Rp ${minLabel} jt`;
  }

  return `Rp ${minLabel}-${maxLabel} jt`;
};
